var RC,
    AMG = AMG || {};
(AMG.collections = AMG.collections || {}),
    ((RC = RC || {}).adminBar = (function (e, t) {
        return {
            init: function () {
                var e = t("#rc-admin-bar"),
                    o = e.find("> button"),
                    a = e.find("> ul").find("> li"),
                    i = a.find("> button"),
                    n = e.find("> p");
                e.length
                    ? (o.on("click", function () {
                          e.hasClass("open") ? (a.removeClass("active"), e.removeClass("open")) : e.addClass("open");
                      }),
                      i.on("click", function () {
                          t(this).parent().hasClass("active") ? t(this).parent().removeClass("active") : (a.removeClass("active"), t(this).parent().addClass("active"));
                      }),
                      setTimeout(function () {
                          var e = t("iframe#admin_bar_iframe").contents(),
                              o = e.find(".store-password > span").html();
                          o.length ? n.find("em").html(o) : n.remove(), e.remove();
                      }, 500))
                    : console.log("Note: you must include 'rc-admin-bar.liquid' in your theme.");
            },
        };
    })(0, jQuery)),
    ((RC = RC || {}).cart = (function (e, t) {
        function o(e) {
            var t;
            try {
                t = JSON.parse(e);
            } catch (e) {
                t = {};
            }
            return t;
        }
        return {
            update: function (o, a, i) {
                t.ajax({ type: "POST", url: "/cart/update.js", data: o, dataType: "json", cache: !1 })
                    .done(function (i) {
                        "function" == typeof a && a(i), t(e).trigger("cart:updated", [i, o]);
                    })
                    .fail(function (a) {
                        "function" == typeof i && i(a), t(e).trigger("cart:failure", [a, o]);
                    });
            },
            add: function (o, a, i) {
                t.ajax({ type: "POST", url: "/cart/add.js", data: o, dataType: "json", cache: !1 })
                    .done(function (i) {
                        "function" == typeof a && a(i), t(e).trigger("cart:item_added", [i, o]);
                    })
                    .fail(function (a) {
                        "function" == typeof i && i(a), t(e).trigger("cart:failure", [a, o]);
                    });
            },
            get: function (e, o) {
                t.ajax({ type: "GET", url: "/cart.js", dataType: "json", cache: !1 })
                    .done(function (t) {
                        "function" == typeof e && e(t);
                    })
                    .fail(function (e) {
                        "function" == typeof o && o(e);
                    });
            },
            change: function (o, a, i) {
                t.ajax({ type: "POST", url: "/cart/change.js", data: o, dataType: "json", cache: !1 })
                    .done(function (i) {
                        "function" == typeof a && a(i), t(e).trigger("cart:changed", [i, o]);
                    })
                    .fail(function (a) {
                        "function" == typeof i && i(a), t(e).trigger("cart:failure", [a, o]);
                    });
            },
            clear: function (e, o) {
                t.ajax({ type: "POST", url: "/cart/clear.js", dataType: "json", cache: !1 })
                    .done(function (t) {
                        "function" == typeof e && e(t), console.log("cart cleared");
                    })
                    .fail(function (t) {
                        "function" == typeof e && o(t);
                    });
            },
            getItem: function (e, o, a) {
                t.ajax({ type: "GET", url: "/products/" + e + ".js", dataType: "json", cache: !1 })
                    .done(function (e) {
                        "function" == typeof o && o(e);
                    })
                    .fail(function (e) {
                        "function" == typeof o && a(e);
                    });
            },
            api: {
                get: function (e, a) {
                    t.ajax({ type: "GET", url: "/cart?view=api", dataType: "html", cache: !1 })
                        .done(function (t) {
                            "function" == typeof e && e(o(t));
                        })
                        .fail(function (e) {
                            "function" == typeof a && a(o(e));
                        });
                },
            },
        };
    })(RC, jQuery)),
    ((RC = RC || {}).floatingLabels = (function (e, t) {
        return {
            floatMyLabels: function (e) {
                for (var o = [].concat(e).length, a = 0; a < o; a++)
                    t(e).on("blur change", function () {
                        t(this).val().length > 0 ? t(this).addClass("filled") : t(this).removeClass("filled");
                    });
            },
        };
    })(0, jQuery)),
    ((RC = RC || {}).sidePanel = (function (e, t) {
        var o = [],
            a = !1;
        return {
            init: function (i, n, r) {
                "function" == typeof t.fn.swipe && (a = !0),
                    t(document).on("keyup", function (t) {
                        27 === t.keyCode && e.sidePanel.close();
                    }),
                    t('.panel_overlay, .side_panel--close, [data-sidepanel-action="close"]').on("click", function (t) {
                        t.preventDefault(), e.sidePanel.close();
                    }),
                    (triggersArray = [].concat(i)),
                    triggersArray.forEach(function (i) {
                        o.push(i),
                            "string" == typeof r && t(n).attr("data-direction") !== r && t(n).attr("data-direction", r),
                            t(i).on("click", function (t) {
                                t.preventDefault(), e.sidePanel.open(n);
                            }),
                            a &&
                                (function (o, a) {
                                    var i = t(o);
                                    switch (a) {
                                        case "up":
                                            i.swipe({
                                                swipeDown: function () {
                                                    e.sidePanel.close();
                                                },
                                            });
                                            break;
                                        case "down":
                                            i.swipe({
                                                swipeUp: function () {
                                                    e.sidePanel.close();
                                                },
                                            });
                                            break;
                                        case "left":
                                            i.swipe({
                                                swipeRight: function () {
                                                    e.sidePanel.close();
                                                },
                                            });
                                            break;
                                        case "right":
                                            i.swipe({
                                                swipeLeft: function () {
                                                    e.sidePanel.close();
                                                },
                                            });
                                    }
                                })(n, t(n).attr("data-direction"));
                    });
            },
            open: function (o) {
                t(o).addClass("open"), t("body").addClass("no-scroll"), t(e.sidePanel).trigger("panel--opening");
            },
            close: function () {
                t(".side_panel.open").removeClass("open"), t("body.no-scroll").removeClass("no-scroll"), t(e.sidePanel).trigger("panel--closing");
            },
            destroy: function () {
                return (
                    o.forEach(function (e) {
                        t(e).off("click"), o.unshift();
                    }),
                    t(e.sidePanel).trigger("panels--destroyed"),
                    !0
                );
            },
        };
    })(RC, jQuery)),
    ((RC = RC || {}).utils = (function (e, t) {
        return {
            shuffle: function (e) {
                var t, o, a;
                for (t = e.length - 1; t > 0; t--) (o = Math.floor(Math.random() * (t + 1))), (a = e[t]), (e[t] = e[o]), (e[o] = a);
                return e;
            },
            urlParam: function (e) {
                return decodeURIComponent((new RegExp("[?|&]" + e + "=([^&;]+?)(&|#|;|$)").exec(location.search) || ["", ""])[1].replace(/\+/g, "%20")) || null;
            },
            urlParams: function (e) {
                return (e || document.location.search)
                    .replace(/(^\?)/, "")
                    .split("&")
                    .map(
                        function (e) {
                            return (this[(e = e.split("="))[0]] = e[1]), this;
                        }.bind({})
                    )[0];
            },
            urlHash: function () {
                return window.location.hash.split("#")[1];
            },
            urlParts: function () {
                return window.location.pathname.split(/\s*\/\s*/).filter(function (e) {
                    return "" != e;
                });
            },
            getClickTouch: function (e, o) {
                t(e).on("click touchstart", function (e) {
                    if ((e.stopPropagation(), e.preventDefault(), !0 === e.handled)) return !1;
                    o(e), (e.handled = !0);
                });
            },
            centsToDollars: function (e) {
                return +e % 100 == 0 ? +e / 100 : (+e / 100).toFixed(2);
            },
            getCookie: function (e) {
                for (var t = e + "=", o = document.cookie.split(";"), a = 0; a < o.length; a++) {
                    for (var i = o[a]; " " == i.charAt(0); ) i = i.substring(1);
                    if (0 == i.indexOf(t)) return i.substring(t.length, i.length);
                }
                return "";
            },
            setCookie: function (e, t, o) {
                var a = new Date();
                a.setTime(a.getTime() + 24 * o * 60 * 60 * 1e3);
                var i = ";Secure;Expires=" + a.toUTCString();
                document.cookie = e + "=" + t + "; " + i;
            },
        };
    })(0, jQuery)),
    ((RC = RC || {}).utils = RC.utils || {}),
    (RC.utils.validate = (function (e, t) {
        var o = new RegExp(
            /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i
        );
        return {
            email: function (e) {
                return !(!e || "" === e.trim() || !o.test(e));
            },
        };
    })(0, jQuery)),
    ((RC = RC || {}).shopifyPreviewButton = (function (e) {
        var t = 0;
        function o(e) {
            window.setTimeout(function () {
                e.style.transform = "translateX(-350px)";
            }, 5e3);
        }
        return {
            init: function () {
                !(function e() {
                    window.setTimeout(function () {
                        if (null !== document.getElementById("shopify-theme-controls"))
                            (a = document.getElementById("shopify-theme-controls")),
                                (i = document.querySelectorAll("a[title=Minimize]")[0]),
                                (n = document.querySelectorAll(".shopify-preview-bar__title")[0]),
                                (r = document.querySelectorAll(".shopify-preview-bar__btn")[0]),
                                a.setAttribute("style", "display: block !important; width: 40px; height: 40px; padding: 5px; pointer-events: none;"),
                                n.setAttribute("style", "position: absolute; left: 45px; bottom: 0; width: 300px; background: rgba(0,0,0,.7); padding: 5px; transition: transform .2s ease-in; transform: translateX(0);"),
                                (n.textContent = n.textContent.replace(/You are currently previewing the theme: /gi, "")),
                                (i.textContent = "×"),
                                i.setAttribute("style", "position: absolute; font-size: 50px; color: white; bottom: -32px; left: -21px; text-decoration: none; pointer-events: auto;"),
                                r.setAttribute("style", "display: none;"),
                                o(n),
                                i.addEventListener("mouseover", function () {
                                    (n.style.transform = "translateX(0)"), o(n);
                                });
                        else {
                            if (t > 30) return;
                            (t += 1), e();
                        }
                        var a, i, n, r;
                    }, 250);
                })();
            },
        };
    })()),
    (AMG.account = (function (e, t) {
        var o = {},
            a = function () {
                o.accordions.on("click", function (e) {
                    var a = t(e.currentTarget),
                        s = {
                            el: a,
                            elTargetId: a.data("accordion-toggle"),
                            elTargetEl: t("#" + a.data("accordion-toggle")),
                            active: a.hasClass("active"),
                            primary: a.hasClass("account-nav__primary-link"),
                            current: a.hasClass("is--current-page"),
                        };
                    if (o.isWishlist || o.isSubscriptions || o.isAddresses || o.isOrder) {
                        if (!o.isMobile || !s.primary) return;
                        e.preventDefault();
                    } else e.preventDefault();
                    if (o.isMobile)
                        s.primary
                            ? s.active
                                ? Accordion.close(s.elTargetId)
                                : s.current
                                ? Accordion.open(s.elTargetId)
                                : (n(), console.log("🔮", a), i(a), Accordion.open(s.elTargetId), r(s.elTargetEl))
                            : s.active || (n(t(".account-nav__secondary-link.active")), Accordion.open(s.elTargetId));
                    else {
                        if (s.active) return;
                        s.primary ? (n(), i(s.el), r(s.elTargetEl)) : n(t(".account-nav__secondary-link.active")), Accordion.open(s.elTargetId);
                    }
                });
            },
            i = function (e) {
                t(".account-nav__primary-link").removeClass("is--current-page"), t("body").attr("data-accountsection", t(e).attr("data-accountsection")), t(e).addClass("is--current-page");
            },
            n = function (e) {
                e || (e = t(".js-accordion.active")),
                    e.each(function () {
                        Accordion.close(t(this).data("accordion-toggle"), !0);
                    });
            },
            r = function (e) {
                var t = e.find("a").first();
                Accordion.open(t.data("accordion-toggle"));
            };
        return {
            init: function () {
                t(document).ready(function () {
                    (o.accordions = t(".js-accordion")),
                        (o.controls = t(".js--account-control")),
                        (o.primaryNav = t(".account-header:visible .account-nav__primary-link")),
                        (o.isMobile = t(".account-header:visible").hasClass("account-header__mobile")),
                        (o.isAccount = t(".account").length > 0),
                        (o.isAddresses = t(".customersaddresses").length > 0),
                        (o.isOrder = t(".customersorder").length > 0),
                        (o.isWishlist = t(".iwishWrapper").length > 0),
                        (o.isSubscriptions = "subscriptions" == t("body").data("accountsection")),
                        (function () {
                            o.accordions.off("click"), a();
                            var e = o.primaryNav.first(),
                                n = window.location.hash.substr(1),
                                r = null,
                                s = null;
                            if (n.length) {
                                if (((r = n.split("-")[0]), (s = n.split("-")[1]), r.length)) {
                                    var c = t('.account-nav:visible [data-accountsection="' + r + '"]');
                                    c.length && (e = c);
                                }
                            } else o.isSubscriptions && (e = t('.account-nav:visible [data-accountsection="subscriptions"]'));
                            i(e);
                            var l = t(e).data("accordion-toggle"),
                                d = t("#" + l)
                                    .find("a")
                                    .first()
                                    .data("accordion-toggle");
                            if (
                                (s && (d = t('.account-subnav:visible [data-accountsubsection="' + s + '"]').data("accordion-toggle")),
                                o.isWishlist && (d = t('.account-subnav:visible [data-accountsubsection="wishlist"]').data("accordion-toggle")),
                                o.isAddresses && (d = t('.account-subnav:visible [data-accountsubsection="settings"]').data("accordion-toggle")),
                                o.isOrder && (d = t('.account-subnav:visible [data-accountsubsection="orders"]').data("accordion-toggle")),
                                o.isSubscriptions)
                            ) {
                                var u,
                                    p = window.location.href;
                                (u =
                                    -1 != p.indexOf("/subscriptions") || -1 != p.indexOf("/products")
                                        ? "recharge-subscriptions"
                                        : -1 != p.indexOf("/delivery_schedule")
                                        ? "recharge-schedule"
                                        : -1 != p.indexOf("/orders")
                                        ? "recharge-history"
                                        : "recharge-account"),
                                    (d = null),
                                    t('.account-subnav [data-accountsubsection="' + u + '"]').addClass("active");
                            }
                            o.isMobile || Accordion.open(l), Accordion.open(d);
                        })();
                });
            },
        };
    })(0, jQuery)),
    (AMG.collection = (function (e, t) {
        return {
            init: function () {
                e.sidecartSettings.enable_sidecart &&
                    t(".product--atc").on("click", function (o) {
                        var a = { id: t(this).closest(".collection_grid--product").attr("data-id"), quantity: 1 };
                        o.preventDefault(),
                            t(this).hasClass("no-atc") ||
                                RC.cart.add(a, function () {
                                    window.location.href.indexOf("cart") > -1 ? location.reload() : e.sidecart.refresh(RC.sidePanel.open("#sidecart"));
                                });
                    }),
                    t(".collection_slider--wrapper").length && t(".collection_slider--wrapper").slick({ dots: !0, adaptiveHeight: !1, responsive: [{ breakpoint: 768, settings: { adaptiveHeight: !0 } }] }),
                    t(".collection_faqs").length &&
                        t(".faq").on("click", function () {
                            t(this).hasClass("active") ? t(".faq.active").removeClass("active") : (t(".faq.active").removeClass("active"), t(this).addClass("active"));
                        });
            },
        };
    })(AMG, jQuery)),
    (AMG.nav = (function (e, t) {
        var o;
        return {
            init: function () {
                window.innerWidth <= 768 &&
                    t(".footer_column--header").on("click", function () {
                        var e,
                            o = t(this).closest(".footer_column"),
                            a = t(this).closest(".footer_column--subcolumn");
                        (e = o), a.length && (e = a), e.hasClass("active") ? e.removeClass("active") : (t(".footer_column.active").removeClass("active"), t(".footer_column--subcolumn.active").removeClass("active"), e.addClass("active"));
                    }),
                    t(".nav--primary_link").on("mouseenter", function (e) {
                        window.clearTimeout(o),
                            t(this).attr("data-dropdown-index")
                                ? (t(".header--dropdown_group.active").removeClass("active"),
                                  t(".header--dropdown:not(.active)").addClass("active"),
                                  t('.header--dropdown_group[data-dropdown-index="' + t(this).attr("data-dropdown-index") + '"]').addClass("active"),
                                  t(".nav--primary_link.open").removeClass("open"),
                                  t(this).addClass("open"))
                                : (t(".header--dropdown.active").removeClass("active"),
                                  t(".nav--primary_link.open").removeClass("open"),
                                  (o = window.setTimeout(function () {
                                      t(".header--dropdown_group.active").removeClass("active");
                                  }, 350)));
                    }),
                    t("#content, #homepage1, .desktop-12, .header--row:nth-child(1), .footer").on("mouseenter", function (e) {
                        t(".header--dropdown.active").removeClass("active"),
                            t(".nav--primary_link.open").removeClass("open"),
                            window.clearTimeout(o),
                            (o = window.setTimeout(function () {
                                t(".header--dropdown_group.active").removeClass("active");
                            }, 350));
                    }),
                    t(".nav--primary_link").on("mouseleave", function (e) {
                        t(e.target).attr("data-dropdown-index") || (t(".header--dropdown.active").removeClass("active"), t(".nav--primary_link.open").removeClass("open"));
                    }),
                    t(".mobile_nav--primary_link[data-panel-index]").on("click", function (e) {
                        e.preventDefault();
                        var o = t(this).attr("data-panel-index");
                        t(".mobile_nav--nav_panel").addClass("secondary_open"), t('.mobile_nav--subnav_panel[data-panel-index="' + o + '"]').addClass("open");
                    }),
                    t(".mobile_nav--close_subpanel").on("click", function (e) {
                        e.preventDefault(), t(".mobile_nav--nav_panel.secondary_open").removeClass("secondary_open"), t(".mobile_nav--subnav_panel.open").removeClass("open");
                    }),
                    t(".header--mobile_trigger").on("click", function (e) {
                        e.preventDefault(),
                            t(".mobile_nav--nav_panel").toggleClass("openMenu"),
                            t(".header--mobile_hamburger, .header--mobile_close").toggleClass("available"),
                            t(".mobile_nav--nav_panel.secondary_open").removeClass("secondary_open");
                    }),
                    t(window).on("resize", function () {
                        t(".mobile_nav--nav_panel.secondary_open").removeClass("secondary_open"),
                            t(".mobile_nav--nav_panel.open, .mobile_nav--subnav_panel.open, .nav--primary_link.open").removeClass("open"),
                            t(".header--mobile_close.available").removeClass("available"),
                            t(".header--mobile_hamburger:not(.available)").addClass("available"),
                            t(".header--dropdown.active").removeClass("active"),
                            Scroll.unlock();
                    }),
                    t(".js--track-referral-cookie").on("click", function () {
                        setTimeout(function () {
                            t(".lion-referral-widget-needs-auth__buttons .lion-action-button").on("click", function () {
                                RC.utils.setCookie("bva_amg_open_referral_modal", !0, 0.25);
                            });
                        }, 1e3);
                    });
                var e = "true" == RC.utils.getCookie("bva_amg_open_referral_modal"),
                    a = !!ENV.customer;
                e &&
                    a &&
                    (RC.utils.setCookie("bva_amg_open_referral_modal", "", 0),
                    setTimeout(function () {
                        window.location.href = window.location.href + "?ll_act=refer";
                    }, 500));
            },
        };
    })(0, jQuery)),
    (AMG.product = (function (e, t) {
        var o;
        function a(e) {
            var o = t(document).scrollTop();
            t(".product_sections--navigation a").each(function () {
                var e = t(this),
                    a = t(e.attr("href"));
                a.position().top <= o + 68 && a.position().top + a.height() > o + 68 ? (t(".product_sections--navigation ul li a").removeClass("active"), e.addClass("active")) : e.removeClass("active");
            });
        }
        function i() {
            t(window).scrollTop() >= o
                ? (t(".product_sections--navigation").addClass("sticky"), t(".product_additional_info").addClass("nav_stuck"), t(".product_sections--top-link").addClass("visible"))
                : (t(".product_sections--navigation.sticky").removeClass("sticky"), t(".product_additional_info.nav_stuck").removeClass("nav_stuck"), t(".product_sections--top-link").removeClass("visible"));
        }
        return {
            init: function () {
                if (
                    (e.sidecartSettings.enable_sidecart &&
                        t(".product-cta-form").on("submit", function (o) {
                            o.preventDefault(), o.stopImmediatePropagation();
                            var a = t(".product-cta-form").serialize();
                            RC.cart.add(a, function () {
                                e.sidecart.refresh(RC.sidePanel.open("#sidecart"));
                            });
                        }),
                    window.innerWidth > 1024 && t(".bigimage").zoom(),
                    t("a.clicker").click(function () {
                        var e = t(this).attr("href");
                        return t(".bigimage img").attr({ src: e }), t(".clicker.active").removeClass("active"), t(this).addClass("active"), !1;
                    }),
                    t("a.next_thumb").on("click", function (e) {
                        e.preventDefault(),
                            t(".clicker.active").parent().next().find(".clicker").length > 0
                                ? t(".clicker.active").parent().next().find(".clicker").trigger("click")
                                : (t(".clicker.active").removeClass("active"), t(".clicker").first().trigger("click"));
                    }),
                    t("a.previous_thumb").on("click", function (e) {
                        e.preventDefault(),
                            t(".clicker.active").parent().prev().find(".clicker").length > 0
                                ? t(".clicker.active").parent().prev().find(".clicker").trigger("click")
                                : (t(".clicker.active").removeClass("active"), t(".clicker").last().trigger("click"));
                    }),
                    t(".product_sections--navigation").length)
                ) {
                    var n = t(".rc_container").innerHeight();
                    (o = t(".product_sections--navigation").offset().top + n + 34),
                        t(window).on("scroll", i),
                        t(document).on("scroll", a),
                        t(".product_sections--navigation a").on("click", function (e) {
                            var o,
                                n = this.hash,
                                r = t(this.hash);
                            e.preventDefault(),
                                t(document).off("scroll"),
                                t(window).off("scroll"),
                                t(".product_sections--navigation a").blur(),
                                t(".product_sections--navigation a.active").removeClass("active"),
                                t(this).addClass("active"),
                                (o = r.offset().top - 68),
                                t("html, body").stop(),
                                t("html, body").animate({ scrollTop: o }, 300, "swing", function () {
                                    console.log(o),
                                        (window.location.hash = n),
                                        r.blur(),
                                        window.setTimeout(function () {
                                            t(document).on("scroll", a), t(window).on("scroll", i);
                                        }, 350);
                                });
                        });
                }
                t("span.pq.left").each(function () {
                    var e = t(this).clone();
                    e.removeClass("pq left"), e.addClass("pulledquote left"), t(this).parent().after(e);
                }),
                    t("span.pq.right").each(function () {
                        var e = t(this).clone();
                        e.removeClass("pq right"), e.addClass("pulledquote right"), t(this).parent().before(e);
                    }),
                    t(".product--wishlist_trigger").on("click", function () {
                        document.querySelector("#wishlistbuttons a").click();
                    }),
                    t(".product_sections--testimonials").length && t(".product_sections--testimonials_slider").slick({ dots: !1, adaptiveHeight: !1, responsive: [{ breakpoint: 768, settings: { adaptiveHeight: !0 } }] }),
                    e.sidecartSettings.enable_sidecart &&
                        t(".atc_cta--form").on("submit", function (o) {
                            o.preventDefault(), o.stopImmediatePropagation();
                            var a = t(".atc_cta--form").serialize();
                            RC.cart.add(a, function () {
                                e.sidecart.refresh(RC.sidePanel.open("#sidecart"));
                            });
                        }),
                    t(".product--quantity_wrapper").on("click", ".decrement, .increment", function () {
                        var e = t(this).hasClass("decrement") ? -1 : 1,
                            o = parseInt(t(".product--quantity").val(), 10);
                        t(".product--quantity").val(o + e);
                    }),
                    t("#product_faqs").length &&
                        t(".faq").on("click", function () {
                            t(this).hasClass("active") ? t(".faq.active").removeClass("active") : (t(".faq.active").removeClass("active"), t(this).addClass("active"));
                        }),
                    t(document).on("closed", ".product_video--embed", function (e) {
                        var o,
                            a = t(e.target).find("iframe");
                        (o = a.attr("src")), a.attr("src", ""), a.attr("src", o);
                    });
                var r = setInterval(function () {
                    !t("input.addtocart").hasClass("disabled") && t("[data-product-form-select]").length && t("input.addtocart").addClass("disabled").attr("disabled", "disabled");
                }, 100);
                t("[data-image-variant]").on("click", function () {
                    var e = t(this).attr("data-image-variant"),
                        o = JSON.parse(e);
                    t("[data-add-to-wishlist]").show(), clearInterval(r), t("input.add.clearfix.addtocart").removeClass("disabled");
                    var a = (o.price / 100).toFixed(2);
                    t("span.product-price").text("$ " + a),
                        o.options.forEach(function (e, a) {
                            t('[data-product-form-select="option' + (a + 1) + '"]')
                                .val(e)
                                .trigger("click"),
                                t('[data-product-form-select-clone="option' + (a + 1) + '"]')
                                    .val(o.id)
                                    .trigger("click");
                            var i = t('[data-discount-variant-id="' + o.id + '"]').attr("value");
                            t("[data-subscription-select]").val(i);
                        });
                }),
                    t("[data-product-form-select]").change(function () {
                        var e = t(this).val(),
                            o = t(this).attr("data-product-form-select");
                        t("[data-add-to-wishlist]").show(),
                            clearInterval(r),
                            t("input.add.clearfix.addtocart").removeClass("disabled"),
                            t('[data-option="' + o + '"]')
                                .val(e)
                                .trigger("change");
                    }),
                    t("[data-add-to-wishlist]").hide();
            },
        };
    })(AMG, jQuery)),
    (AMG.sidecart = (function (e, t) {
        var o = {};
        (o.sidecartSettings = e.sidecartSettings),
            (o.enablePromo = e.enablePromo),
            (o.enablePromoMessage = e.enablePromoMessage),
            (o.promoType = e.promoType),
            (o.promoProduct = e.promoProduct),
            (o.promoCode = e.promoCode),
            (o.promoSKU = e.promoSKU),
            (o.promoId = e.promoId),
            (o.promoSKUorId = e.promoSKUorId),
            (o.promoThreshold = e.promoThreshold),
            (o.promoEnd = e.promoEnd),
            (o.havePromoItem = !1),
            (o.haveSKUItem = !1),
            (o.adjustTotal = !1),
            (o.promoCollection = e.promoCollection),
            (o.promoProductAvailable = e.promoProductAvailable);
        var a = {},
            i = t("#sidecart-line-item").html(),
            n = t("#sidecart-promo-item").html(),
            r = !1;
        function s(s) {
            RC.cart.api.get(function (l) {
                var d = l.cart;
                if (d && d.items) {
                    var u = {}, em = !1, total = 0, h = !0;
                    t(".sidecart--line_items").empty(),
                        (r = !1),
                        (d.items = d.items.sort(function (e, t) {
                            return e.id === o.promoProduct ? -1 : 0;
                        }));
                    for (var f = 0; f < d.items.length; f++) {
                        var m = d.items[f];
                        if (m.upsell) {
                            var v = m;
                            d.items.splice(f, 1), d.items.push(v);
                        }
                        if (d.items[f].id == 30863921643594) {
                            var h = !1;
                        }
                    }
                    if (((d.items = d.items.reverse()), d && d.items && d.items.length)) {
                        (o.haveSKUItem = !1), (o.adjustTotal = !1);
                        for (var yt = 0, yyt = 0, g = d.items.length - 1; g >= 0; g--) {
                            var C = "$" + (d.items[g].price.unit / 100).toFixed(2),
                                b = "",
                                _ = !0,
                                y = !1,
                                yy = !1,
                                w = d.items[g].url.includes("selling_plan"),
                                k = "",
                                F = 100 - (d.items[g].price.unit / d.items[g].product.price) * 100;
                            if ((console.log(F), 1 == w)) k = F.toFixed() + ".00% Off Auto renew";
                            d.items[g].product.variants[0].sku == o.promoSKU && "promo_sku" == o.promoSKUorId && (o.haveSKUItem = !0),
                                d.items[g].id == o.promoId && "promo_id" == o.promoSKUorId && (o.haveSKUItem = !0),
                                d.items[g].id == o.promoProduct ? ((b = !0), (_ = ""), (o.adjustTotal = d.items[g].price.unit)) : ((b = ""), (_ = !0)),
                                49434900231 == d.items[g].id && "true" === e.cacaoSpoonAvailable && (y = !0) && (em = !0) && (yt = d.items[g].quantity),
                                40479063081034 == d.items[g].id && "true" === e.cacaoSpoonAvailable && (yy = !0) && (em = !0) && (yyt = d.items[g].quantity),
                                (u = {
                                    id: d.items[g].id,
                                    sku: d.items[g].product.variants[0].sku,
                                    image: d.items[g].product.images[0].url,
                                    price: C,
                                    handle: d.items[g].product.handle,
                                    discount: k,
                                    title: d.items[g].product.title,
                                    quantity: d.items[g].quantity,
                                    variant: d.items[g].variant_title,
                                    index: g + 1,
                                    upsell: !1,
                                    promoId: o.promoProduct,
                                    promoSKU: o.promoSKU,
                                    normal: _,
                                    gift: b,
                                    cacaoMask: y,
                                    haiSerum: yy,
                                    thereIsNoSpoon: h,
                                }),console.log(u),
                                d.items[g].is_subscription && (r = !0),
                                d.items[g].upsell &&
                                    e.sidecartSettings.enable_upsells &&
                                    (u.upsell = {
                                        id: d.items[g].upsell.product.id,
                                        sku: d.items[g].product.sku,
                                        handle: d.items[g].upsell.handle,
                                        heading: d.items[g].upsell.heading,
                                        text: d.items[g].upsell.text,
                                        content: d.items[g].upsell.content,
                                        image: d.items[g].upsell.image,
                                        title: d.items[g].upsell.product.title,
                                        variant_title: d.items[g].upsell.product.variant_title,
                                        variant: d.items[g].upsell.product.variant_id,
                                        price: "$" + (d.items[g].upsell.product.price / 100).toFixed(2),
                                    }),
                                b ? (t(".sidecart__promo--remove").attr("data-id", u.id).fadeIn(), t(".sidecart__promo__item").html(Mustache.render(n, u)).fadeIn()) : t(".sidecart--line_items").append(Mustache.render(i, u));
                        }
                        total = yt + yyt;
                        if(em == !0 && h == !1) {
                            console.log(total+ "#########");
                            t('[data-id="30863921643594"]').find('input').attr("value",total);
                            RC.cart.change({ id: 30863921643594, quantity: total });
                        } else if (em == !1 && h == !1) {
                            t('[data-id="30863921643594"]').find('.line_item--remove').trigger( "click" );
                            // t('[data-id="30863921643594"]').removeAttr("data-id", "").fadeOut();
                            RC.cart.change({ id: 30863921643594, quantity: 0 });
                        }
                        (checkoutUrl = c()),
                            t(".sidecart--total").text("$" + (d.total_price / 100).toFixed(2)),
                            t(".sidecart--empty.visible, .sidecart--continue_shopping.visible").removeClass("visible"),
                            t(
                                ".sidecart--checkout_btn:not(.visible), .sidecart--line_items:not(.visible), .sidecart--header_cart_items:not(.visible), .sidecart--continue_cart:not(.visible), .sidecart--secondary_close:not(.visible)"
                            ).addClass("visible"),
                            t(".sidecart--checkout_btn").attr("href", checkoutUrl),
                            a.sidecartPromo && a.sidecartPromo.fadeIn("fast");
                    } else
                        t(".sidecart--line_items.visible, .sidecart--continue_cart.visible, .sidecart--checkout_btn.visible, .sidecart--header_cart_items.visible, .sidecart--secondary_close.visible").removeClass("visible"),
                            t(".sidecart--empty:not(.visible), .sidecart--continue_shopping:not(.visible)").addClass("visible"),
                            a.sidecartPromo && a.sidecartPromo.fadeOut("fast");
                    o.enablePromo &&
                        o.promoProductAvailable &&
                        RC.cart.get(function (e) {
                            p(e);
                        }),
                        d && (t(".sidecart--count").text("(" + d.products_count + ")"), t(".header--cart_count").text(d.products_count)),
                        "function" == typeof s && s();
                }
            });
        }
        function c() {
            var e = ENV.shop.shopify_domain.replace("https://", ""),
                t = Cookies.get("cart"),
                o = ENV.customer ? ENV.customer.id : "",
                a = ENV.customer ? ENV.customer.email : "",
                i = "/checkout";
            if (r) {
                try {
                    var n = ga.getAll()[0].get("linkerParam");
                } catch (e) {
                    n = "";
                }
                i = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" + e + "&cart_token=" + t + "&" + n + "&customer_id=" + o + "&customer_email=" + a;
            }
            return i;
        }
        function l(e, t) {
            RC.cart.change({ id: parseInt(e, 10), quantity: parseInt(t, 10) }, function (e) {
                s();
            });
        }
        function d(e) {
            t(this).siblings("[data-update-cart]").addClass("active");
        }
        function u(e) {
            e.preventDefault();
            var a = t(this).closest(".sidecart--line_item"),
                i = a.find(".line_item--qty").val();
            if (0 == i) {
                var n = !1;
                a.attr("data-id") == o.promoProduct && (n = !0), v(a.attr("data-id"), a.attr("data-id"), n, parseInt(a.find(".line_item--qty").val(), 10) - 1);
            }
            if ("free-cosmetic-spoon" === a.attr("data-handle")) {
                var r = t('[data-handle="charcoal-cacao-mask"]');
                if (0 == r.length || parseInt(r.find(".line_item--qty").val()) <= i) return !1;
            }
            l(a.attr("data-id"), i);
        }
        var p = function (e) {
                !o.enablePromoMessage && a.sidecartPromo && a.sidecartPromo.fadeOut("fast"), f();
                var t = (function (e) {
                    var t = Math.round(e.total_price / 100);
                    return a.sidecart.find('[data-id="' + o.promoProduct + '"]').length > 0 && (t -= Math.round(o.adjustTotal / 100)), t;
                })(e);
                "threshold" === o.promoType && b(t), "promo_sku" === o.promoType && y(t);
            },
            f = function () {
                RC.cart.get(function (e) {
                    _.find(e.items, function (e) {
                        return e.id === o.promoProduct;
                    }) && RC.cart.change({ id: o.promoProduct, quantity: 1 }, function (e) {});
                });
            },
            m = function (e, o, a) {
                var i = t(".sidecart--line_items").find('[data-id="' + e + '"]'),
                    n = 1;
                o.isInteger && (n = o), i.length > 0 && !a ? ((n = parseInt(i.find(".js-sidecart-product-quantity").text(), 10) + n), l(e, o)) : h(e, n, a, !0);
            },
            v = function (e, t) {
                var a = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                    i = arguments[3];
                i || (i = 0), t == o.promoProduct && a && w(), l(e, i);
            },
            h = function (e, o, a) {
                arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
                    arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
                    RC.cart.add(
                        { id: e, quantity: o, properties: a },
                        function () {
                            s(function () {
                                t(".sidecart--line_items").scrollTop(0);
                            });
                        },
                        function (e) {
                            console.error(e);
                        }
                    );
            },
            g = function () {
                RC.cart.get(function (e) {
                    e.items.forEach(function (e) {
                        e.properties && e.properties.Promo_Product && "true" === e.properties.Promo_Product && e.id !== o.promoProduct && v(e.id, e.id, !1, 0);
                    });
                });
            },
            C = function (e, o) {
                var a = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                t(".sidecart__promo--remove").removeAttr("data-id", "").fadeOut(),
                    t(".sidecart__promo__item").fadeOut(),
                    t(".sidecart__promo__item").empty(),
                    RC.cart.get(function (e) {
                        e.items.forEach(function (e) {
                            e.properties && e.properties.Promo_Product && "true" === e.properties.Promo_Product && v(e.id, e.id, a, 0);
                        });
                    });
            },
            b = function (e) {
                var t = o.promoThreshold - e,
                    i = a.sidecart.find('[data-id="' + o.promoProduct + '"]').length > 0,
                    n = a.sidecart.find('[data-id="' + o.promoProduct + '"]').attr("data-id");
                g();
                var r = "1" === sessionStorage.getItem("hasRemovedPromoProduct");
                t > 0
                    ? (C(n),
                      (i || r) &&
                          a.sidecartPromoSuccess.fadeOut("fast", function () {
                              return a.sidecartPromoDetails.fadeIn("fast");
                          }),
                      a.sidecartPromoProgress.css("width", (e / o.promoThreshold) * 100 + "%"),
                      a.sidecartPromoThreshold.text("$" + t))
                    : i || r
                    ? (r && a.sidecartPromoReadd.show(),
                      !o.enablePromoMessage && a.sidecartPromo && a.sidecartPromo.fadeIn("fast"),
                      a.sidecartPromoDetails.fadeOut("fast", function () {
                          return a.sidecartPromoSuccess.fadeIn("fast");
                      }))
                    : (a.sidecartPromoProgress.css("width", "100%"),
                      a.sidecartPromoThreshold.text("$0"),
                      a.sidecartPromoDetails.fadeOut("fast", function () {
                          return a.sidecartPromoSuccess.fadeIn("fast");
                      }),
                      m(o.promoProduct, 1, { Promo_Product: "true" }));
            },
            y = function (e) {
                var t = a.sidecart.find('[data-id="' + o.promoProduct + '"]').length > 0,
                    i = a.sidecart.find('[data-id="' + o.promoProduct + '"]').attr("data-id"),
                    n = "1" === sessionStorage.getItem("hasRemovedPromoProduct");
                g(),
                    o.haveSKUItem
                        ? !o.haveSKUItem || t || n
                            ? o.haveSKUItem &&
                              (n && a.sidecartPromoReadd.show(),
                              o.enablePromoMessage || a.sidecartPromo.fadeIn("fast"),
                              a.sidecartPromoDetails.fadeOut("fast", function () {
                                  return a.sidecartPromoSuccess.fadeIn("fast");
                              }))
                            : (a.sidecartPromoDetails.fadeOut("fast", function () {
                                  return a.sidecartPromoSuccess.fadeIn("fast");
                              }),
                              m(o.promoProduct, 1, { Promo_Product: "true" }))
                        : (C(i),
                          (t || n) &&
                              a.sidecartPromoSuccess.fadeOut("fast", function () {
                                  return a.sidecartPromoDetails.fadeIn("fast");
                              }));
            },
            w = function () {
                sessionStorage.setItem("hasRemovedPromoProduct", "1");
            };
        return {
            init: function () {
                Mustache.parse(i),
                    Mustache.parse(n),
                    (a.body = t("body")),
                    (a.sidecart = t(".js-sidecart")),
                    (a.open = t(".js-open-sidecart")),
                    (a.close = t(".js-close-sidecart")),
                    (a.totalItems = t(".js-sidecart-total-items")),
                    (a.navTotalItems = t("#minicart-count")),
                    (a.emptyMessage = t(".js-sidecart-empty")),
                    (a.itemList = t(".js-sidecart-items")),
                    (a.variantSelect = t(".js-product-variant-selector")),
                    (a.sidecartTotal = t(".js-sidecart-total")),
                    (a.quantitySelect = t(".js-product-quantity-selector")),
                    (a.sidecartDrawer = t(".js-sidecart-drawer")),
                    (a.sidecartDrawerImage = t(".js-sidecart-drawer-image")),
                    (a.sidecartDrawerTitle = t(".js-sidecart-drawer-title")),
                    (a.openSidecartFromDrawer = t(".js-open-sidecart-from-drawer")),
                    (a.sidecartPromo = t(".js-sidecart-promo")),
                    (a.sidecartPromoDetails = t(".js-sidecart-promo-details")),
                    (a.sidecartPromoSuccess = t(".js-sidecart-promo-success")),
                    (a.sidecartPromoReadd = t(".js-sidecart-promo-re-add")),
                    (a.sidecartPromoTimer = t(".js-sidecart-promo-timer")),
                    (a.sidecartPromoThreshold = t(".js-sidecart-promo-threshold")),
                    (a.sidecartPromoProgress = t(".js-sidecart-promo-progress")),
                    (a.checkoutBtn = t('button[name="checkout"]')),
                    RC.sidePanel.init(".header--cart_link", "#sidecart"),
                    s(function () {
                        "cart" == RC.utils.urlHash() && RC.sidePanel.open("#sidecart");
                    }),
                    t(".side_panel--footer").on("click", ".sidecart--checkout_btn.bold_clone", function (e) {
                        RC.sidePanel.close();
                    }),
                    t(".sidecart__promo--remove").click(function (e) {
                        e.preventDefault();
                        var o = t(this).attr("data-id");
                        o && C(o, o, !0);
                    }),
                    t(".sidecart--line_items").on("click", "[data-update-cart]", u),
                    t(".sidecart--line_items").on("click", ".line_item--remove", function (e) {
                        var o = t(this).closest(".sidecart--line_item");
                        e.preventDefault(), v(o.attr("data-id"), o.attr("data-id"), !0, 0);
                    }),
                    t(".sidecart--line_items").on("input", ".line_item--qty", d),
                    t(".sidecart--line_items").on("click", ".line_item--increment", function (e) {
                        e.preventDefault();
                        var o = t(this).closest(".sidecart--line_item"),
                            a = o.find(".line_item--qty").val();
                        if ("free-cosmetic-spoon" === o.attr("data-handle")) {
                            var i = t('[data-handle="charcoal-cacao-mask"]'),
                                ii = t('[data-handle="smoothing-hair-serumn"]');
                            if (0 == i.length || 0 == ii.length || parseInt(i.find(".line_item--qty").val()) + parseInt(ii.find(".line_item--qty").val()) <= a) return !1;
                        }
                        l(o.attr("data-id"), parseInt(a, 10) + 1);
                    }),
                    t(".sidecart--line_items").on("click", ".line_item--decrement", function (e) {
                        var a = t(this).closest(".sidecart--line_item");
                        e.preventDefault();
                        var i = !1;
                        a.attr("data-id") == o.promoProduct && (i = !0), v(a.attr("data-id"), a.attr("data-id"), i, parseInt(a.find(".line_item--qty").val(), 10) - 1);
                    }),
                    t(".sidecart--line_items").on("click", ".upsell--atc", function (e) {
                        var o,
                            a = t(this).closest(".sidecart--line_item_upsell");
                        e.preventDefault(),
                            (o = a.attr("data-id")),
                            RC.cart.add(
                                { id: o, quantity: 1 },
                                function () {
                                    s(function () {
                                        t(".sidecart--line_items").scrollTop(0);
                                    });
                                },
                                function (e) {
                                    console.error(e);
                                }
                            );
                    }),
                    a.sidecartPromoReadd.on("click", function () {
                        sessionStorage.removeItem("hasRemovedPromoProduct"), a.sidecartPromoReadd.fadeOut("fast"), m(o.promoProduct, 1, { Promo_Product: "true" });
                    });
            },
            refresh: s,
            checkoutUrl: c,
            rechargeStatus: r,
        };
    })(AMG, jQuery)),
    (function (e, t) {
        var o = {},
            a = function (e) {
                ($toggle = o.accordion.filter('[data-accordion-toggle="' + e + '"]')),
                    ($content = t('[data-accordion-content="' + e + '"]')),
                    $toggle.addClass("active").attr("aria-expanded", "true"),
                    $content.slideDown("slow").attr("aria-hidden", "false");
            },
            i = function (e, a) {
                ($toggle = o.accordion.filter('[data-accordion-toggle="' + e + '"]')),
                    ($content = t('[data-accordion-content="' + e + '"]')),
                    $toggle.removeClass("active").attr("aria-expanded", "false"),
                    a ? $content.hide() : $content.slideUp("slow"),
                    $content.attr("aria-hidden", "true");
            };
        (e.init = function () {
            (o.accordion = t(".js-accordion")),
                o.accordion.each(function () {
                    var e = t(this);
                    ($content = t("#" + e.data("accordion-toggle"))),
                        e.hasClass("active") || i(e.data("accordion-toggle"), !0),
                        e.attr("aria-controls", e.data("accordion-toggle")).attr("aria-expanded", "false"),
                        $content.attr("aria-hidden", "true");
                }),
                o.accordion.on("click", function (e) {
                    ($toggle = t(e.currentTarget)), e.preventDefault(), $toggle.hasClass("active") ? i($toggle.data("accordion-toggle")) : a($toggle.data("accordion-toggle"));
                });
        }),
            (e.open = a),
            (e.close = i);
    })((window.Accordion = window.Accordion || {}), jQuery),
    (function (e, t) {
        e.init = function () {
            t(document).on("click", ".js-bs-add-to-cart", function (e) {
                var o = t(e.currentTarget);
                e.preventDefault(),
                    RC.cart.add({ id: o.data("product-id"), quantity: 1 }, function () {
                        AMG.sidecart.refresh(RC.sidePanel.open("#sidecart"));
                    });
            }),
                t(document).on("click", ".js-bs-shop", function (e) {
                    var o = t(e.currentTarget);
                    e.preventDefault();
                    var a = "/collections/" + o.data("product-collection") + o.data("product-url");
                    window.location.href = a;
                });
        };
    })((window.BestSellers = window.BestSellers || {}), jQuery),
    (function (e, t) {
        var o = {},
            a = function (e) {
                t(e.currentTarget).siblings("[data-update-cart]").addClass("active");
            },
            i = function (e) {
                e.preventDefault();
                var a = t(e.currentTarget);
                a.removeClass("active"), a.siblings("[data-updating-cart]").addClass("active"), o.cartForm.submit();
            };
        e.init = function () {
            (o.cartForm = t("#cartform")),
                (o.lineItemControl = t("[data-line-item-control]")),
                (o.lineItemInput = t("[data-line-item-input]")),
                (o.updateCartLink = t("[data-update-cart]")),
                o.lineItemControl.on("click", function (e) {
                    !(function (e) {
                        var o = t(e.currentTarget),
                            a = o.attr("line-item-id"),
                            i = o.attr("data-line-item-control"),
                            n = t("[data-line-item-input=" + a + "]");
                        "increment" === i
                            ? n.val(function (e, t) {
                                  return ++t;
                              })
                            : "decrement" === i &&
                              n.val(function (e, t) {
                                  return 0 == t ? 0 : --t;
                              });
                    })(e),
                        a(e);
                }),
                o.lineItemInput.on("input", a),
                o.updateCartLink.on("click", i);
        };
    })((window.CartPage = window.CartPage || {}), jQuery),
    (function (e, t) {
        var o = {};
        e.init = function () {
            (o.carousel = t(".js-collections-carousel")), o.carousel.slick({ slidestoShow: 1, dots: !0, arrows: !1, infinite: !0 });
        };
    })((window.CollectionsCarousel = window.CollectionsCarousel || {}), jQuery),
    (function (e, t) {
        var o = {};
        e.init = function () {
            (o.productCount = t(".js-mega-collection-total-products")), (o.products = t(".js-collections-product")), o.productCount.text(o.products.length + " Items");
        };
    })((window.CollectionsUtil = window.CollectionsUtil || {}), jQuery),
    (function (e, t) {
        ($checkbox = t("[data-cart-spoon-checkbox]")), ($spoonLineItem = t("#div_30863921643594"));
        var o = function (e, ee, o) {
            if (ee == "") { 
                if (e == "") { 
                    console.log(1111);
                    (o.val(0), t("#cartform").submit()); 
                } else {
                    console.log(2222);
                    o.val(e.val());
                }
            } else {
                if (e == "") { 
                    console.log(3333);
                    o.val(ee.val());
                } else {
                    console.log(44444);
                    o.val(parseInt(e.val()) + parseInt(ee.val())); 
                }
            }
        };
        if ($spoonLineItem.length > 0) {
            var a = "", aa = "";
            if (t("#div_49434900231").length > 0) var a = t("#div_49434900231").find('input[type="number"]');
            if (t("#div_40479063081034").length > 0) var aa = t("#div_40479063081034").find('input[type="number"]');
            var i = $spoonLineItem.find('input[type="number"]');
            o(a, aa, i),
                i.on("change", function () {
                    o(a, aa, i);
                });
                if (a != "") {
                    a.on("change", function () {
                        o(a, aa, i);
                    });
                }
                if (aa != "") {
                    aa.on("change", function () {
                        o(a, aa, i);
                    });
                }
        }
        (e.addSpoon = function (e) {
            if (!(t('[data-id="30863921643594"]').length > 0)) { 
                console.log(11111111);
                var total = 0, x = 0, y = 0;
                if ((t('[data-id="49434900231"]').length > 0)) {
                    var x = t('[data-id="49434900231"]').find('input').val();
                }
                if ((t('[data-id="40479063081034"]').length > 0)) {
                    var y = t('[data-id="40479063081034"]').find('input').val();
                }
                total = parseInt(x) + parseInt(y);
                if ((t('[data-id="49434900231"]').length > 0) || (t('[data-id="40479063081034"]').length > 0)) {
                    a = { quantity: total, id: 30863921643594 };
                } else {
                    a = { quantity: o ? parseInt($checkbox.attr("data-quantity")) : e, id: 30863921643594 };
                }
                var o = window.location.pathname.includes("cart");
                RC.cart.add(
                    a,
                    function () {
                        o ? location.reload() : AMG.sidecart.refresh(RC.sidePanel.open("#sidecart"));
                    },
                    function (e) {
                        console.log("error adding:", e), t("[data-cart-spoon-checkbox]").html("<label>Sorry, but the spoons are currently out of stock</label>");
                    }
                );
            }
        }),
            $checkbox.one("click", e.addSpoon);

    })((window.FreeSpoon = window.FreeSpoon || {}), jQuery),
    (function (e, t) {
        "use strict";
        var o = {},
            a = bodyScrollLock.disableBodyScroll,
            i = bodyScrollLock.enableBodyScroll,
            n = function () {
                var e = document.querySelector(".js-gift-note-modal");
                o.giftNoteForm.removeClass("is-hidden"), o.giftNoteSuccess.removeClass("is-active"), o.modal.addClass("is-active"), o.overlay.addClass("is-active"), a(e);
            },
            r = function () {
                var e = document.querySelector(".js-gift-note-modal");
                o.modal.removeClass("is-active"), o.overlay.removeClass("is-active"), i(e), "" == o.giftNote && (o.openModal.attr("checked", !1), o.giftNoteLabel.removeClass("is-active"));
            },
            s = function (e) {
                t(e.currentTarget).hasClass("is-active")
                    ? (o.giftNoteLabel.removeClass("is-active"), c(), o.giftNoteLabelSpan.html("This is a gift. Add a note to this order."), o.editNote.removeClass("is-active"))
                    : o.openModal.trigger("change");
            },
            c = function () {
                t.post("/cart/update.js", { attributes: { "Gift Note": null } });
            };
        e.init = function () {
            (o.openModal = t(".js-add-gift-note")),
                (o.closeModal = t(".js-modal-close, .bva-overlay")),
                (o.modal = t(".js-gift-note-modal")),
                (o.giftNote = o.modal.find("textarea")),
                (o.editNote = t(".js-edit-note")),
                (o.giftNoteForm = t(".js-gift-note-form")),
                (o.giftNoteLabel = t(".js-gift-note-label")),
                (o.giftNoteLabelSpan = t(".js-gift-note-label-span")),
                (o.giftNoteSuccess = t(".js-gift-note-success")),
                (o.overlay = t(".bva-overlay")),
                o.giftNoteLabel.on("click", s),
                o.openModal.on("change", n),
                o.giftNoteForm.on("submit", function (e) {
                    var a;
                    e.preventDefault(),
                        (a = o.giftNote.val()),
                        t.post("/cart/update.js", { attributes: { "Gift Note": a } }),
                        o.giftNoteForm.addClass("is-hidden"),
                        o.giftNoteSuccess.addClass("is-active"),
                        o.giftNoteLabel.addClass("is-active"),
                        o.giftNoteLabelSpan.html("This order contains a gift note."),
                        o.editNote.addClass("is-active");
                }),
                o.closeModal.on("click", r),
                o.editNote.on("click", function (e) {
                    e.preventDefault(), n();
                });
        };
    })((window.GiftNote = window.GiftNote || {}), jQuery),
    (function (e, t) {
        var o = {};
        e.init = function () {
            (o.slider = t(".js-shop-instagram-slider")),
                o.slider.slick({
                    slidesToShow: 4,
                    responsive: [
                        { breakpoint: 680, settings: { centerMode: !0, slidesToShow: 1, arrows: !1 } },
                        { breakpoint: 960, settings: { centerMode: !0, slidesToShow: 3, arrows: !1 } },
                    ],
                });
        };
    })((window.InstagramSlider = window.InstagramSlider || {}), jQuery),
    (function (e, t) {
        "use strict";
        var o = {};
        (e.show = function (e) {
            var a = t('[data-modal="' + e + '"]');
            o.body.attr("data-active-modal", e),
                a
                    .fadeIn(300, function () {
                        return a.trigger("modal-opened");
                    })
                    .addClass("show");
        }),
            (e.hide = function (e) {
                var a = t('[data-modal="' + e + '"]');
                o.body.removeAttr("data-active-modal"),
                    a.fadeOut(300, function () {
                        return a.trigger("modal-closed").removeClass("show");
                    });
            }),
            (e.init = function () {
                (o.body = t("body")),
                    (o.modal = t("[data-modal]")),
                    (o.modalShow = t("[data-open-modal]")),
                    (o.modalHide = t("[data-close-modal]")),
                    o.modalShow.on("click", function (e) {
                        e.preventDefault(), window.Modal.show(t(this).data("open-modal"));
                    }),
                    o.modalHide.on("click", function (e) {
                        e.preventDefault(), window.Modal.hide(t(this).data("close-modal"));
                    });
            });
    })((window.Modal = window.Modal || {}), jQuery),
    (function (e, t) {
        var o = bodyScrollLock.disableBodyScroll,
            a = bodyScrollLock.enableBodyScroll,
            i = {},
            n = void parseInt(Cookies.get("referralCount")),
            r = !1,
            s = function (e) {
                (errorMessage = e), i.formError.html(errorMessage), i.formError.addClass("is-active"), i.sendSpan.removeClass("is-hidden"), i.loading.removeClass("is-active");
            },
            c = function (e) {
                var t = document.querySelector(".js-samples-modal");
                i.modal.removeClass("is-active"), i.overlay.removeClass("is-active"), a(t);
            },
            l = function () {
                (void 0 === Cookies.get("referralCount") || isNaN(Cookies.get("referralCount"))) && Cookies.set("referralCount", 0);
            };
        e.init = function () {
            var e;
            (i.form = t(".js-growsurf-form")),
                (i.firstName = t(".js-first-name")),
                (i.lastName = t(".js-last-name")),
                (i.email = t(".js-email")),
                (i.referredBy = t(".js-referred-by")),
                (i.formError = t(".js-samples-error")),
                (i.modal = t(".js-samples-modal")),
                (i.modalEntry = t(".js-samples-modal-entry")),
                (i.overlay = t(".js-bva-overlay")),
                (i.modalClose = t(".js-modal-close")),
                (i.sendSpan = t(".js-samples-send")),
                (i.loading = t(".js-samples-loading")),
                i.form.on("submit", function (e) {
                    e.preventDefault(),
                        (function () {
                            if (r) return !1;
                            l(), i.sendSpan.addClass("is-hidden"), i.loading.addClass("is-active");
                            var e = { firstName: i.firstName.val(), lastName: i.lastName.val(), email: encodeURIComponent(i.email.val()), referredBy: "" + n };
                            if ("" == e.firstName || "" == e.lastName || "" == e.email) s("Please fill out every field");
                            else if (parseInt(Cookies.get("referralCount")) > 2) s("Oops! Looks like you have already referred three friends");
                            else {
                                r = !0;
                                var a = "https://growsurf-production.herokuapp.com/friends?first_name=" + e.firstName + "&last_name=" + e.lastName + "&email=" + e.email + "&referred_by=" + e.referredBy;
                                console.log(e),
                                    t.ajax({
                                        type: "GET",
                                        url: encodeURI(a),
                                        headers: { "Access-Control-Allow-Origin": "*" },
                                        success: function (e) {
                                            var t, a;
                                            "failure" === e.status
                                                ? s(e.message)
                                                : ((t = document.querySelector(".js-samples-modal")),
                                                  (a = parseInt(Cookies.get("referralCount")) + 1) > 2
                                                      ? i.modalEntry.html(
                                                            '\n\t\t\t<h3 class="samples__modal-headline">Thank you!</h3>\n\t\t\t<p>Your form was successfully submitted.</p>\n\t\t\t<a class="samples__modal-return" href="/collections/all">Click Here to Return to Our Shop</a>\n\t'
                                                        )
                                                      : i.modalEntry.html(
                                                            '\n\t\t\t<h3 class="samples__modal-headline">Sent!</h3>\n\t\t\t<button class="samples__modal-close js-modal-close">Add Another Friend</button>\n\t\t\t<a class="samples__modal-return" href="/collections/all">Click Here to Return to Our Shop</a>\n\t'
                                                        ),
                                                  i.modal.addClass("is-active"),
                                                  i.overlay.addClass("is-active"),
                                                  o(t),
                                                  i.firstName.val(""),
                                                  i.lastName.val(""),
                                                  i.email.val(""),
                                                  i.sendSpan.removeClass("is-hidden"),
                                                  i.loading.removeClass("is-active"),
                                                  i.formError.removeClass("is-active"),
                                                  Cookies.set("referralCount", a));
                                        },
                                        complete: function () {
                                            r = !1;
                                        },
                                    });
                            }
                        })();
                }),
                t("body").on("click", ".js-modal-close", c),
                i.overlay.on("click", c),
                l(),
                (e = {}),
                window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (t, o, a) {
                    e[o] = a;
                }),
                (n = e.email);
        };
    })((window.Samples = window.Samples || {}), jQuery),
    (function (e, t) {
        var o = jQuery("body");
        (e.lock = function () {
            o.addClass("locked");
        }),
            (e.unlock = function () {
                o.removeClass("locked");
            });
    })((window.Scroll = window.Scroll || {})),
    (function (e, t) {
        var o = t(".js-search-form"),
            a = t(".js-search"),
            i = t(".js-search-results"),
            n = t(".js-rotate-search"),
            r = t(".js-search-placeholder"),
            s = t(".js-search-close"),
            c = t(".js-results-grid"),
            l = t(".js-results-count"),
            d = n.data("rotate").split(","),
            u = !1,
            p = function (e, o) {
                c.append('<div class="js-placeholder" data-index="' + o + '"></div>'),
                    t.get("/products/" + e + "?view=search-item", function (e) {
                        c.find(".js-placeholder[data-index=" + o + "]").replaceWith(e), t(".grid-item.is-hidden").removeClass("is-hidden");
                    });
            },
            f = function (e) {
                var t = e.tags.find(function (e) {
                        return e.indexOf("search-type:") > -1;
                    }),
                    o = "";
                return (
                    (o += '<a class="grid-item grid-item-wide" href="/products/' + e.handle + '" title="' + e.title + '">'),
                    (o += '<div class="grid-image-wrapper"><img src="' + e.product_image + '" alt="' + e.title + '" class="grid-image" /></div>'),
                    (o += '<div class="grid-info"><p class="grid-title">' + e.title + "</p>"),
                    void 0 !== t && (o += '<p class="grid-short-info">' + t.split(":")[1] + "</p>"),
                    o + "</div></a>"
                );
            },
            m = function (e, t) {
                if (void 0 !== e.hits) {
                    var o = "",
                        a = (function (e) {
                            var t = [];
                            return (
                                e.forEach(function (e) {
                                    t.find(function (t) {
                                        return t.id === e.id;
                                    }) || t.push(e);
                                }),
                                t
                            );
                        })(e.hits),
                        n = a.length;
                    if ("grid" == t) {
                        var r = n > 1 ? n + " results" : n + " result";
                        l.html(r).parent().fadeIn(300);
                    }
                    for (var s = 0; s < n; s++)
                        if ("grid" == t) p(a[s].handle, s);
                        else if (((o += f(a[s])), s >= 4 || s >= n - 1)) {
                            (o += '<div class="search-prod-footer">Press Enter to See All Results</div>'), i.html(o), i.prev().hide();
                            break;
                        }
                }
            },
            v = function (e, t) {
                "" === e
                    ? h(!0)
                    : u &&
                      u.search({ query: e }, function (e, o) {
                          if (e) throw e;
                          m(o, t);
                      });
            },
            h = function (e) {
                e ? (r.removeClass("is-hidden"), i.prev().show(), i.html("")) : r.addClass("is-hidden");
            },
            g = function (e) {
                e ? (o.addClass("is-active"), t(window).innerWidth() < 846 && Scroll.lock(), h(!1)) : (Scroll.unlock(), o.removeClass("is-active"), a.val() || h(!0));
            };
        e.init = function () {
            var e;
            a
                .on("change keyup", function (e) {
                    t(this).val() ? (v(t(this).val(), m), h(!1)) : h(!0);
                })
                .on("focusin", function () {
                    g(!0);
                })
                .on("focusout", function () {
                    g(!1);
                }),
                s.on("click", function () {
                    return g(!1), !1;
                }),
                t(".search-results").on("mousedown touchstart", function (e) {
                    var o = t(e.target).parents("a");
                    null != t(o).attr("href") && (window.location.href = t(o).attr("href"));
                }),
                (function e(t) {
                    (t = void 0 === t || void 0 === d[t] ? 0 : t),
                        n.addClass("is-hidden"),
                        setTimeout(function () {
                            n.text(d[t]).removeClass("is-hidden"),
                                setTimeout(function () {
                                    e(t + 1);
                                }, 3e3);
                        }, 500);
                })(),
                (e = algoliasearch("5YZQ1X6FQ3", "445ac15cba46e2455e0d4e7b606a4bbd")),
                (u = e.initIndex("shopify_products")),
                "/search" === window.location.pathname && "" !== window.location.search && v(window.location.search.split("=")[1], "grid");
        };
    })((window.Search = window.Search || {}), jQuery),
    (function (e, t) {
        var o = {};
        e.init = function () {
            (o.select = t(".js-select-nav")),
                o.select.change(function (e) {
                    window.location.href = t(e.currentTarget).val();
                });
        };
    })((window.SelectNav = window.SelectNav || {}), jQuery),
    (function (e, t) {
        var o = {};
        e.init = function () {
            (o.slider = t(".js-shop-hero")), o.slider.slick({ arrows: !1, dots: !0 });
        };
    })((window.ShopHero = window.ShopHero || {}), jQuery),
    (function (e, t) {
        var o = bodyScrollLock.disableBodyScroll,
            a = bodyScrollLock.enableBodyScroll,
            i = {},
            n = function (e) {
                var a = t(e.currentTarget).attr("data-handle");
                t.get("/products/" + a + "?view=subscription-modal")
                    .done(function (e) {
                        i.overlay.addClass("is-active"), i.modalEntry.html(e), i.subscriptionModal.addClass("is-active");
                        var t = document.querySelector(".js-subscription-modal");
                        o(t);
                    })
                    .fail(function (e) {
                        console.error("product get fail", e);
                    });
            },
            r = function (e) {
                i.overlay.removeClass("is-active"), i.subscriptionModal.removeClass("is-active");
                var t = document.querySelector(".js-subscription-modal");
                a(t);
            };
        e.init = function () {
            (i.overlay = t(".bva-overlay")),
                (i.openModal = t(".js-open-subscription-modal")),
                (i.modalEntry = t(".js-subscription-modal-entry")),
                (i.subscriptionModal = t(".js-subscription-modal")),
                (i.closeModal = t(".js-modal-close")),
                i.openModal.on("click", n),
                t(document).on("submit", ".product-cta-form", function (e) {
                    e.preventDefault(),
                        e.stopImmediatePropagation(),
                        window.selectionMade
                            ? (function (e) {
                                  if (AMG.sidecartSettings.enable_sidecart) {
                                      var o = t(e).serialize();
                                      RC.cart.add(o, function () {
                                          r(), window.location.href.indexOf("cart") > -1 ? (window.scrollTo(0, 0), location.reload()) : AMG.sidecart.refresh(RC.sidePanel.open("#sidecart"));
                                      });
                                  }
                              })(this)
                            : t(".product-variants-quantity").addClass("is-error");
                }),
                t(document).on("click", ".js-modal-close", r),
                i.overlay.on("click", r),
                t(document).on("click", ".increment", function (e) {
                    e.preventDefault(), console.log(t(".recharge-modal-input").attr("value"));
                    var o = parseInt(t(".atc_cta--quantity").attr("value")) + 1;
                    t(".atc_cta--quantity").attr("value", o);
                }),
                t(document).on("click", ".decrement", function (e) {
                    e.preventDefault();
                    var o = parseInt(t(".recharge-modal-input").attr("value")) - 1;
                    0 === o && (o = 1), t(".atc_cta--quantity").attr("value", o);
                });
        };
    })((window.SubscriptionModal = window.SubscriptionModal || {}), jQuery),
    (function (e, t) {
        var o = {},
            a = [],
            i = function (e) {
                var o = t(e.currentTarget),
                    i = o.attr("data-variant-id");
                return o.toggleClass("is-active"), -1 != a.indexOf(i) ? a.splice(a.indexOf(i), 1) : a.push(i), a;
            },
            n = function (e) {
                var t = "/",
                    o = "?";
                e.map(function (e, a) {
                    return a > 0 && (o = "&"), (t += o + "id[]=" + e), e;
                }),
                    e.length ? (window.location.href = "https://shop.annmariegianni.com/cart/add" + t) : alert("Please select a product!");
            },
            r = function () {
                o.upsellProduct.not(".is-active, .is-selected").trigger("click"),
                    setTimeout(function () {
                        n(a);
                    }, 600);
            };
        e.init = function () {
            (o.upsellProduct = t(".js-upsell-product")),
                (o.addItems = t(".js-upsell-add")),
                (o.addAll = t(".js-upsell-add-all")),
                o.upsellProduct.on("click", i),
                o.addItems.on("click", function () {
                    return n(a);
                }),
                o.addAll.on("click", r);
        };
    })((window.Upsell = window.Upsell || {}), jQuery),
    (function (e, t) {
        e.init = function () {};
    })((window.CrossSell = window.CrossSell || {}), jQuery),
    (AMG.router = (function (e, t) {
        return {
            init: function () {
                e.nav.init(),
                    !t('body[data-template="cart"]').length && e.sidecartSettings.enable_sidecart && e.sidecart.init(),
                    t(".collection_grid--product").length && e.collection.init(),
                    t('body[data-template="product"]').length && e.product.init(),
                    t('body[data-template="product.product-with-top-select"]').length && e.product.init(),
                    (t(".account").length || t(".customersorder").length || t(".iwishWrapper").length || t("#ReCharge").length) && e.account.init();
            },
        };
    })(AMG, jQuery)),
    AMG.router.init();
